export default __webpack_public_path__ + "static/media/buddy-dual-wielder.47d30470.png";